// Esqueleto cinza da inicial enquanto os dados chegam: nunca tela em branco.
// As medidas seguem os cartões de verdade para a página não pular ao carregar.
export default function EsqueletoInicio() {
  const bloco = 'esqueleto rounded-[16px] bg-background-200/70';

  return (
    <div className="mt-3 space-y-4" aria-hidden>
      {/* Oração de hoje */}
      <div className={`${bloco} h-[118px]`} />

      {/* À venda agora: espaço da arte em 16:9 (nunca um bloco gigante) */}
      <div className="pt-2">
        <div className="esqueleto h-4 w-32 rounded-full bg-background-200/70" />
        <div className="mt-3 overflow-hidden rounded-[16px] bg-background-50 shadow-pcard">
          <div className="esqueleto aspect-video w-full bg-background-200/70" />
          <div className="space-y-2 p-4">
            <div className="esqueleto h-4 w-3/4 rounded-full bg-background-200/70" />
            <div className="esqueleto h-3 w-1/2 rounded-full bg-background-200/70" />
            <div className="esqueleto h-4 w-24 rounded-full bg-background-200/70" />
            <div className="esqueleto h-11 w-full rounded-[12px] bg-background-200/70" />
          </div>
        </div>
      </div>

      {/* Em breve */}
      <div className="pt-1">
        <div className="esqueleto h-4 w-24 rounded-full bg-background-200/70" />
        <div className="mt-3 space-y-2.5">
          <div className={`${bloco} h-[124px]`} />
          <div className={`${bloco} h-[124px]`} />
        </div>
      </div>
    </div>
  );
}